<template>
  <div class="offerte" v-loading="loading">

    <transition name="fade">
      <ricerca 
        v-show="showSearchPanel"
        @closeRicerca="closeSearch"
        @cerca="cerca"
        @loadingOff="loading = false"
      />
    </transition>

    <div class="header-tab col-24 no-padding row row-custom">
      <div class="col-2 no-padding icon-search">
        <el-button @click="openSearch">
          <el-tooltip class="item" effect="dark" :content="$t('quotazioni.cerca')" placement="top-start">
            <icon name="riv-filter" scale="1.4"></icon>
          </el-tooltip>
        </el-button>
      </div>
    </div>

    <el-table :data="quotazioni" class="custom-table">
      <el-table-column
        header-align="center" align="center"
        width="70"
      >
        <template slot="header" slot-scope="scope">
          <el-popover 
            :key="scope.length"
            placement="top"
            width="365"
            trigger="click"
            popper-class="custom-popover"
          >
            <div slot="reference">
              <icon name="riv-help" class="pointer" scale="1"></icon>
            </div>
            <div class="legenda">
              <div class="row row-custom">
                <div class="col-4 no-padding custom-icon">
                  <!-- NUOVE OFFERTE NON HANNO ICONA -->
                </div>
                <div class="col-20 custom-label">
                  {{ $t('quotazioni.N') }}
                </div>
              </div>
              <div class="row row-custom">
                <div class="col-4 no-padding custom-icon">
                  <icon style="color: black" name="riv-saveDoc" scale="1.2"></icon>
                </div>
                <div class="col-20 custom-label">
                  {{ $t('quotazioni.S') }}
                </div>
              </div>
              <div class="row row-custom">
                <div class="col-4 no-padding custom-icon">
                  <icon style="color: black" name="riv-sendDoc" scale="1.2"></icon>
                </div>
                <div class="col-20 custom-label">
                  {{ $t('quotazioni.I') }}
                </div>
              </div>
              <div class="row row-custom">
                <div class="col-4 no-padding custom-icon">
                  <icon style="color: black" name="riv-waitDoc" scale="1.2"></icon>
                </div>
                <div class="col-20 custom-label">
                  {{ $t('quotazioni.attesaDoc') }}
                </div>
              </div>
              <div class="row row-custom">
                <div class="col-4 no-padding custom-icon">
                  <icon style="color: black" name="riv-waitEuro" scale="1.2"></icon>
                </div>
                <div class="col-20 custom-label">
                  {{ $t('quotazioni.propostaAlternativa') }}
                </div>
              </div>
              <div class="row row-custom">
                <div class="col-4 no-padding custom-icon">
                  <icon style="color: black" name="riv-reOpen" scale="1.2"></icon>
                </div>
                <div class="col-20 custom-label">
                  {{ $t('quotazioni.riaperta') }}
                </div>
              </div>
            </div>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <div class="stato-wrapper" v-if="scope.row.dataInvio">
            <el-tooltip class="item" effect="dark" :content="moment(scope.row.dataInvio, 'DDMMYYYY').format('DD/MM/YYYY')" placement="top">
              <icon style="color: black" v-if="(scope.row.codAvanz === '020' || scope.row.codAvanz === '021')" name="riv-sendDoc" scale="1.2" />
              <icon style="color: black" v-if="(scope.row.codAvanz === '015' || scope.row.codAvanz === '017')" name="riv-saveDoc" scale="1.2" />
              <icon style="color: black" v-if="(scope.row.codAvanz === '011')" name="riv-waitDoc" scale="1.2" />
              <icon style="color: black" v-if="(scope.row.codAvanz === '025')" name="riv-waitEuro" scale="1.2" />
              <icon style="color: black" v-if="(scope.row.codAvanz === '012' || scope.row.codAvanz === '016')" name="riv-reOpen" scale="1.2" />
            </el-tooltip>
          </div>
          <div class="stato-wrapper" v-else>
            <icon style="color: black" v-if="(scope.row.codAvanz === '020' || scope.row.codAvanz === '021')" name="riv-sendDoc" scale="1.2" />
            <icon style="color: black" v-if="(scope.row.codAvanz === '015' || scope.row.codAvanz === '017')" name="riv-saveDoc" scale="1.2" />
            <icon style="color: black" v-if="(scope.row.codAvanz === '011')" name="riv-waitDoc" scale="1.2" />
            <icon style="color: black" v-if="(scope.row.codAvanz === '025')" name="riv-waitEuro" scale="1.2" />
            <icon style="color: black" v-if="(scope.row.codAvanz === '012' || scope.row.codAvanz === '016')" name="riv-reOpen" scale="1.2" />
          </div>
        </template>
      </el-table-column>

      <el-table-column 
        header-align="center" align="center"
        :label="$t('quotazioni.anno')"
        width="60"
      >
        <template slot-scope="scope">
          <div class="data-wrapper">
            {{ moment(scope.row.data, 'DDMMYYYY').format('YYYY') }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        header-align="center" align="center" class-name="sfondino"
        :label="$t('quotazioni.numRichiesta')"
        width="115"
      >
        <template slot-scope="scope">
          <div class="name-wrapper pointer" @click="selectQuotazione(scope.row)">
            {{ scope.row.numRif }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="desc" header-align="center" align="center"
        :label="$t('quotazioni.descrizione')"
        min-width="250"
      />

      <el-table-column
        header-align="center" align="center"
        :label="$t('quotazioni.tipo')"
        width="150"
      >
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="(scope.row.tipoRich + ' - ' + scope.row.descRich)" placement="top">
            <div class="name-wrapper">
              {{ scope.row.tipoRich + ' - ' + scope.row.descRich }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column 
        header-align="center" align="center"
        :label="$t('quotazioni.data')"
        width="110"
      >
        <template slot-scope="scope">
          <div class="data-wrapper">
            {{ moment(scope.row.dataRicez, 'DDMMYYYY').format('DD/MM/YYYY') }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="descStab"
        header-align="center" align="center"
        :label="$t('quotazioni.stabilimento')"
        min-width="130"
      />

      <el-table-column 
        header-align="center" align="center"
        :label="$t('quotazioni.sopralluogo')"
        width="110"
      >
        <template slot-scope="scope">
          <div class="sopralluogo-wrapper">
            {{ (scope.row.ifSopral === 'Y') ? $t('quotazioni.necessario').toUpperCase() : $t('quotazioni.nonNecessario').toUpperCase() }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="descSoc"
        header-align="center" align="center"
        :label="$t('quotazioni.societa')"
        min-width="135"
      />

      <el-table-column 
        header-align="center" align="center"
        :label="$t('quotazioni.dataScadenza')"
        width="150"
      >
        <template slot-scope="scope">
          <div class="data-wrapper">
            {{ (scope.row.dataScad) ? moment(scope.row.dataScad, 'DDMMYYYY').format('DD/MM/YYYY') : '' }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        width="35"
      >
        <template slot-scope="scope">
          <div class="name-wrapper pointer actions" @click="selectQuotazione(scope.row)">
            <icon name="riv-arrow" scale="1.1"></icon>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination 
      v-if="(nrPages > 1)" 
      :current-page="currentPage" 
      class="custom-pagination"
      background
      layout="prev, pager, next"
      :total="nrItems"
      :page-size="pag_for"
      @current-change="changePage"
    />

  </div>
</template>

<script>
  import Ricerca from './Ricerca.vue'
  import {bus} from '@/components/Bus.js'
  import moment from 'moment'

  export default {
    name: 'Quotazioni',
    components: {Ricerca},
    i18n: {
      messages: {
        it_IT: {
          quotazioni: {
            stabilimento: 'Stabilimento',
            numRichiesta: 'Nr. Richiesta',
            descrizione: 'Descrizione',
            data: 'Data',
            societa: 'Società',
            sopralluogo: 'Sopralluogo',
            eseguitoIl: 'Eseguito il',
            I: 'RDQ Inviata',
            S: 'RDQ Salvata',
            N: 'Nuova RDQ',
            attesaDoc: 'RDQ in attesa di altri Documenti',
            cerca: 'Cerca',
            si: 'Sì',
            anno: 'Anno',
            propostaAlternativa: 'Prop. alternativa in fase di valutazione',
            riaperta: 'Quotazione riaperta',
            tipo: 'Tipologia',
            dataScadenza: 'Data Scadenza',
            necessario: 'Necessario',
            nonNecessario: 'Non necessario'
          }
        },
        fr_FR: {
          quotazioni: {
            stabilimento: 'Etablissement',
            numRichiesta: 'Nr. Requête',
            descrizione: 'Déscription',
            data: 'Date',
            societa: 'Société',
            sopralluogo: 'Inspection',
            eseguitoIl: 'Réalisé le',
            I: 'RDD envoyée',
            S: 'RDD mise à jour',
            N: 'Nouvelle RDD',
            attesaDoc: 'RDD en attente de documents supplémentaires',
            cerca: 'Recherche',
            si: 'Oui',
            anno: 'Année',
            propostaAlternativa: 'Proposition alternative en phase d\'évaluation',
            riaperta: 'RDD réouverte',
            tipo: 'Typologie',
            dataScadenza: 'Date Expiration',
            necessario: 'Nécessaire',
            nonNecessario: 'Non nécessaire'
          }
        },
        es_ES: {
          quotazioni: {
            stabilimento: 'Almacen',
            numRichiesta: 'Nº. Petición',
            descrizione: 'Descripción',
            data: 'Fecha',
            societa: 'Sociedad',
            sopralluogo: 'Inspección',
            eseguitoIl: 'Realizado el',
            I: 'PDO Enviada',
            S: 'PDO Guardada',
            N: 'Nueva PDO',
            attesaDoc: 'PDO en espera de documentación adicional',
            cerca: 'Busqueda',
            si: 'Si',
            anno: 'Año',
            propostaAlternativa: 'Propuesta alternativa en fase de evaluación',
            riaperta: 'Petición reabierta',
            tipo: 'Tipología',
            dataScadenza: 'Fecha Vencimiento',
            necessario: 'Necesario',
            nonNecessario: 'No necesario'
          }
        },
        de_DE: {
          quotazioni: {
            stabilimento: 'Werk',
            numRichiesta: 'Anfrage Nr.',
            descrizione: 'Beschreibung',
            data: 'Datum',
            societa: 'Unternehmen',
            sopralluogo: 'Inspektion',
            eseguitoIl: 'Ausgeführt am',
            I: 'Angebotsanfrage gesendet',
            S: 'Angebotsanfrage gespeichert',
            N: 'Neue Angebotsanfrage',
            attesaDoc: 'Angebotsanfrage in Erwartung weiterer Dokumente',
            cerca: 'Suche',
            si: 'Ja',
            anno: 'Jahr',
            propostaAlternativa: 'Alternativvorschlag in Prüfung',
            riaperta: 'Angebot wiedereröffnet',
            tipo: 'Typologie',
            dataScadenza: 'Ablaufdatum',
            necessario: 'Erforderlich',
            nonNecessario: 'Nicht erforderlich'
          }
        },
        en_GB: {
          quotazioni: {
            stabilimento: 'Stabilimento',
            numRichiesta: 'Nr. Richiesta',
            descrizione: 'Descrizione',
            data: 'Data',
            societa: 'Società',
            sopralluogo: 'Sopralluogo',
            eseguitoIl: 'Eseguito il',
            I: 'RDQ Inviata',
            S: 'RDQ Salvata',
            N: 'Nuova RDQ',
            attesaDoc: 'RDQ in attesa di altri Documenti',
            cerca: 'Cerca',
            si: 'Sì',
            anno: 'Anno',
            propostaAlternativa: 'Prop. alternativa in fase di valutazione',
            riaperta: 'Quotazione riaperta',
            tipo: 'Tipo',
            dataScadenza: 'Expiration Date',
            necessario: 'Necessary',
            nonNecessario: 'Not necessary'
          }
        }
      }
    },
    data () {
      return {
        moment: moment,
        loading: true,
        codLang: sessionStorage.getItem('codLang'),
        showSearchPanel: false,
        form: {
          country: '',
          codForn: '',
          codSoc: '',
          codStab: '',
          annoRic: '',
          numRif: '',
          codAvanz: ''
        },
        quotazioni: [],
        pag_for: 12,
        currentPage: 1,
        nrPages: 0,
        nrItems: 0
      }
    },
    mounted: function () {
      bus.$on('changeLanguage', () => {
        this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
      })
      bus.$on('Header_SetCodFornAdmin', () => {
        this.$set(this, 'quotazioni', [])
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'nrItems', 0)
        this.$set(this, 'currentPage', 1)
      })
      bus.$on('UFFACQ_ChangeCountryFromDsh', () => {
        this.$set(this, 'quotazioni', [])
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'nrItems', 0)
        this.$set(this, 'currentPage', 1)
      })
    },
    activated: function () {
      this.init()
    },
    deactivated: function () {
      this.resetDati()
    },
    methods: {
      init: function () {
        this.$nextTick(() => {
          this.$store.dispatch('ifObject', 'RDQ_Ricerca')
            .then((ifRicerca) => {
              if (ifRicerca) {
                let form = this.$store.state.RDQ_Ricerca
                this.$set(this, 'form', form)
                this.ricerca()
              }
            })
        })
      },
      resetDati: function () {
        this.$set(this, 'loading', true)
        this.$set(this, 'showSearchPanel', false)
        let form = {
          country: '',
          codForn: '',
          codSoc: '',
          codStab: '',
          annoRic: '',
          numRif: '',
          codAvanz: ''
        }
        this.$set(this, 'form', form)
        this.$set(this, 'quotazioni', [])
        this.$set(this, 'currentPage', 1)
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'nrItems', 0)
      },
      openSearch: function () {
        this.$set(this, 'showSearchPanel', true)
        this.$emit('hideScroll')
        this.$emit('closeMessages')
      },
      closeSearch: function () {
        this.$emit('showScroll')
        this.$set(this, 'showSearchPanel', false)
      },
      changePage: function (page) {
        this.$set(this, 'currentPage', page)
        this.ricerca()
      },
      selectQuotazione: function (quotazione) {
        this.$store.commit('set', {key: 'RDQ_Quotazione', value: quotazione})
        this.$router.push({name: 'RdQDettaglioQuotazione'})
      },
      cerca: function (form) {
        let formRicerca = JSON.parse(form)
        this.$set(this, 'form', formRicerca)
        this.$set(this, 'currentPage', 1)
        if (!this._inactive) {
          this.ricerca()
        }
      },
      ricerca: function () {
        this.$set(this, 'loading', true)
  
        // Flag per sapere se ho cambiato Stato e/o codForn
        let flagChange = false
  
        // Se il codForn salvato nel sessionStorage è diverso da quello in utilizzo nel component allora lo cambio
        if (sessionStorage.getItem('UFFACQ_fornitore') !== this.form.codForn) {
          sessionStorage.setItem('UFFACQ_fornitore', this.form.codForn)
          flagChange = true
        }
  
        // Se lo Stato salvato nel localStorage è diverso da quello in utilizzo nel component allora lo cambio
        if (localStorage.getItem('UFFACQ_country') !== this.form.country) {
          localStorage.setItem('UFFACQ_country', parseInt(this.form.country))
          flagChange = true
        }
        bus.$emit('Header_ChangeAdmin', this.form.country, 'UFFACQ')

        // Sono cambiati Stato e/o codForn
        if (flagChange) {
          bus.$emit('UFFACQ_ChangeCountryFromApp')
        }

        this.$http.get('richiestediquotazione/quotazioni', {
          params: {
            codLang: this.codLang,
            codForn: this.form.codForn,
            country: this.form.country,
            codSoc: this.form.codSoc,
            codStab: this.form.codStab,
            annoRic: this.form.annoRic,
            numRif: this.form.numRif,
            codAvanz: this.form.codAvanz,
            pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
            pag_from: this.currentPage,
            pag_for: this.pag_for
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$store.commit('set', {key: 'RDQ_Ricerca', value: this.form})
              this.$set(this, 'quotazioni', response.body.data)

              if (this.currentPage === 1) {
                this.$set(this, 'nrItems', parseInt(response.body.attrib.size))
                this.$set(this, 'nrPages', parseInt(response.body.attrib.pages))
              }

              this.closeSearch()
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this, 'loading', false)
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .offerte {
    .header-tab {
      height: 65px;
      text-align: center;
      .icon-search {
        line-height: 65px;
        .el-button {
          height: 40px;
          width: 40px;
          border-radius: 0;
          margin-top: 12px;
          margin-left: 10px;
          padding: 0;
          color: @greenRiva;
          float: left;
          border: 1px solid @greenRiva;
        }
        .el-button:hover {
          background-color: @white;
        }
      }
    }
    .el-table {
      height: 460px;
      margin-top: 5px;
      .el-table__header {
        thead {
          th {
            .cell {
              .el-popover__reference {
                padding-top: 0;
                line-height: 16px;
              }
            }
          }
        }
      }
      .el-table__body {
        tr {
          .cell {
            .actions {
              text-align: right;
              padding-right: 7px;
            }
            .pdf {
              text-align: right;
            }
          }
        }
      }
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/Fornitura/RichiesteDiQuotazione/Quotazioni.vue